import * as bootstrap from "bootstrap";
import Swiper from 'swiper/bundle';
import AOS from "aos";
import PureCounter from '@srexi/purecounterjs';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

const floorPlan = document.querySelectorAll(".floor-plan .floor-apartment");
const floorPlanOverlay = document.querySelectorAll(".apartment-overlays .overlay-vertical");

const buildingPlan = document.querySelectorAll(".building-plan .floor");
const floorOverlayAnchors = document.querySelectorAll(".building-plan .overlay-anchor");
const floorOverlay = document.querySelectorAll(".floor-overlays .overlay-vertical");

const projectBuildings = document.querySelectorAll(".project-plan polygon");
const buildingOverlayAnchors = document.querySelectorAll(".project-plan .overlay-anchor");
const buildingOverlays = document.querySelectorAll(".building-overlays .overlay-vertical");

const projectPlotElements = document.querySelectorAll(".project-plot-plan .plot-list-element");
const plotOverlayAnchors = document.querySelectorAll(".project-plot-plan .overlay-anchor");
const plotOverlays = document.querySelectorAll(".plot-overlays .overlay-vertical");

const projectPlanApartments = document.querySelectorAll(".project-plan .project-apartment");

function setBuildingOverlayPosition(building, overlay) {
    overlay.style.top = window.scrollY + building.top - overlay.offsetHeight / 2 + "px";
    overlay.style.left = window.scrollX + building.left - overlay.offsetHeight / 2 + "px";
}

function setPlotOverlayPosition(plot, overlay) {
    overlay.style.top = window.scrollY + plot.top - overlay.offsetHeight / 2 + "px";
    overlay.style.left = window.scrollX + plot.left - overlay.offsetHeight / 2 + "px";
}

function setFloorOverlayPosition(floor, overlay) {
    overlay.style.top = window.scrollY + floor.top - overlay.offsetHeight / 2 + "px";
    overlay.style.left = window.scrollX + floor.left - overlay.offsetHeight / 2 + "px";
}

function setFloorPlanOverlayPosition(apartment, overlay) {
    overlay.style.top = window.scrollY + apartment.top + apartment.height / 2 - 24 + "px";
    overlay.style.left = window.scrollX + apartment.left + apartment.width / 2 - 24 + "px";
}

function initBuildingOverlay() {
    if (projectBuildings) {
        for (let i = 0; i < projectBuildings.length; i++) {
            buildingOverlays[i].style.position = "absolute";
            setBuildingOverlayPosition(buildingOverlayAnchors[i].getBoundingClientRect(), buildingOverlays[i]);

            projectBuildings[i].addEventListener("mouseenter", event => {
                buildingOverlays[i].children[0].style.zIndex = 4;
                buildingOverlays[i].children[1].style.zIndex = 3;
                buildingOverlays[i].children[1].classList.add("visible");
            });
            projectBuildings[i].addEventListener("mouseleave", event => {
                buildingOverlays[i].children[1].classList.remove("visible");
                buildingOverlays[i].children[1].style.zIndex = 1;
                buildingOverlays[i].children[0].style.zIndex = 2;
            });
            if (projectBuildings[i].dataset.url !== "private") {
                projectBuildings[i].addEventListener("click", event => {
                    location.href = projectBuildings[i].dataset.url;
                });
            }
        }
    }
}

function initPlotOverlay() {
    if (projectPlotElements) {
        for (let i = 0; i < projectPlotElements.length; i++) {
            plotOverlays[i].style.position = "absolute";
            setPlotOverlayPosition(plotOverlayAnchors[i].getBoundingClientRect(), plotOverlays[i]);
            projectPlotElements[i].addEventListener("mouseenter", event => {
                plotOverlays[i].children[0].style.zIndex = 4;
                plotOverlays[i].children[1].style.zIndex = 3;
                plotOverlays[i].children[1].classList.add("visible");
            });
            projectPlotElements[i].addEventListener("mouseleave", event => {
                plotOverlays[i].children[1].classList.remove("visible");
                plotOverlays[i].children[1].style.zIndex = 1;
                plotOverlays[i].children[0].style.zIndex = 2;
            });
            if (projectPlotElements[i].dataset.url !== "private") {
                projectPlotElements[i].addEventListener("click", event => {
                    location.href = projectPlotElements[i].dataset.url;
                });
            }
        }

    }
}

function initFloorOverlay() {
    if (buildingPlan) {
        for (let i = 0; i < buildingPlan.length; i++) {
            floorOverlay[i].style.position = "absolute";
            setFloorOverlayPosition(floorOverlayAnchors[i].getBoundingClientRect(), floorOverlay[i]);
            buildingPlan[i].addEventListener("mouseenter", event => {
                floorOverlay[i].children[0].style.zIndex = 4;
                floorOverlay[i].children[1].style.zIndex = 3;
                floorOverlay[i].children[1].classList.add("visible");
            });
            buildingPlan[i].addEventListener("mouseleave", event => {
                floorOverlay[i].children[1].classList.remove("visible");
                floorOverlay[i].children[1].style.zIndex = 1;
                floorOverlay[i].children[0].style.zIndex = 2;
            });
            if (buildingPlan[i].dataset.url !== "private") {
                buildingPlan[i].addEventListener("click", event => {
                    location.href = buildingPlan[i].dataset.url;
                });
            }
        }

    }
}

function initFloorPlanOverlay() {
    if (floorPlan) {
        for (let i = 0; i < floorPlan.length; i++) {
            floorPlanOverlay[i].style.position = "absolute";
            setFloorPlanOverlayPosition(floorPlan[i].getBoundingClientRect(), floorPlanOverlay[i]);
            floorPlan[i].addEventListener("mouseenter", event => {
                floorPlanOverlay[i].children[0].style.zIndex = 4;
                floorPlanOverlay[i].children[1].style.zIndex = 3;
                floorPlanOverlay[i].children[1].classList.add("visible");
            });
            floorPlan[i].addEventListener("mouseleave", event => {
                floorPlanOverlay[i].children[1].classList.remove("visible");
                floorPlanOverlay[i].children[1].style.zIndex = 1;
                floorPlanOverlay[i].children[0].style.zIndex = 2;
            });
            if (floorPlan[i].dataset.url !== "private") {
                floorPlan[i].addEventListener("click", event => {
                    location.href = floorPlan[i].dataset.url;
                });
            }
        }
    }
}
function initProjectPlan() {
    if (projectPlanApartments) {
        console.log(projectPlanApartments);
        for (let i = 0; i < projectPlanApartments.length; i++) {
            // floorPlanOverlay[i].style.position = "absolute";
            // setFloorPlanOverlayPosition(floorPlan[i].getBoundingClientRect(), floorPlanOverlay[i]);
            // floorPlan[i].addEventListener("mouseenter", event => {
            //     floorPlanOverlay[i].children[0].style.zIndex = 4;
            //     floorPlanOverlay[i].children[1].style.zIndex = 3;
            //     floorPlanOverlay[i].children[1].classList.add("visible");
            // });
            // floorPlan[i].addEventListener("mouseleave", event => {
            //     floorPlanOverlay[i].children[1].classList.remove("visible");
            //     floorPlanOverlay[i].children[1].style.zIndex = 1;
            //     floorPlanOverlay[i].children[0].style.zIndex = 2;
            // });
            if (projectPlanApartments[i].dataset.url !== "private") {
                projectPlanApartments[i].addEventListener("click", event => {
                    location.href = projectPlanApartments[i].dataset.url;
                });
            }
        }
    }
}

function refreshBuildingOverlay() {
    if (projectBuildings) {
        for (let i = 0; i < projectBuildings.length; i++) {
            setBuildingOverlayPosition(buildingOverlayAnchors[i].getBoundingClientRect(), buildingOverlays[i]);
        }
    }
}

function refreshFloorOverlay() {
    if (buildingPlan) {
        for (let i = 0; i < buildingPlan.length; i++) {
            setFloorOverlayPosition(floorOverlayAnchors[i].getBoundingClientRect(), floorOverlay[i]);
        }
    }
}

function refreshPlotOverlay() {
    if (projectPlotElements) {
        for (let i = 0; i < projectPlotElements.length; i++) {
            setPlotOverlayPosition(plotOverlayAnchors[i].getBoundingClientRect(), plotOverlays[i]);
        }
    }
}

function refreshFloorPlanOverlay() {
    if (floorPlan) {
        for (let i = 0; i < floorPlan.length; i++) {
            setFloorPlanOverlayPosition(floorPlan[i].getBoundingClientRect(), floorPlanOverlay[i]);
        }
    }
}

const mediaQueryMainMenu = window.matchMedia("(min-width: 1500px)");
const mediaQueryApartman = window.matchMedia( "(min-width: 992px)");

var windowWidth = window.innerWidth;
window.addEventListener("resize", function () {
    if (window.innerWidth !== windowWidth) {
        if ( mediaQueryApartman.matches ) {
            windowWidth = window.innerWidth;
            refreshBuildingOverlay();
            // refreshFloorOverlay();
            // refreshFloorPlanOverlay();
            // refreshPlotOverlay();
        }
    }
});

document.addEventListener("DOMContentLoaded", function (event) {
    AOS.init();
    const pureCounter = new PureCounter();
    initBuildingOverlay();
    // initFloorOverlay();
    // initFloorPlanOverlay();
    // initPlotOverlay();
    initProjectPlan();

    let referencesSlider = new Swiper("#references-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
        },
    });
});